import React from "react";
import Box from "@material-ui/core/Box";

export default function () {
  return <Box>Home Page</Box>;
}
